var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoldUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5732 41.9111V37.4864C37.5732 35.1394 36.6475 32.8885 34.9997 31.2289C33.3519 29.5694 31.1169 28.637 28.7866 28.637H11.2134C8.88301 28.637 6.64811 29.5694 5.0003 31.2289C3.35249 32.8885 2.42676 35.1394 2.42676 37.4864V41.9111M28.7866 10.9383C28.7866 15.8256 24.8527 19.7876 20 19.7876C15.1473 19.7876 11.2134 15.8256 11.2134 10.9383C11.2134 6.05087 15.1473 2.08887 20 2.08887C24.8527 2.08887 28.7866 6.05087 28.7866 10.9383Z",
    stroke: "#DCF4F0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldUser);
export default "data:image/svg+xml,%3csvg width='40' height='44' viewBox='0 0 40 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M37.5732 41.9111V37.4864C37.5732 35.1394 36.6475 32.8885 34.9997 31.2289C33.3519 29.5694 31.1169 28.637 28.7866 28.637H11.2134C8.88301 28.637 6.64811 29.5694 5.0003 31.2289C3.35249 32.8885 2.42676 35.1394 2.42676 37.4864V41.9111M28.7866 10.9383C28.7866 15.8256 24.8527 19.7876 20 19.7876C15.1473 19.7876 11.2134 15.8256 11.2134 10.9383C11.2134 6.05087 15.1473 2.08887 20 2.08887C24.8527 2.08887 28.7866 6.05087 28.7866 10.9383Z' stroke='%23DCF4F0' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };